import moment from 'moment';

export function getLimitePetiteCaisse(eglise, pcCompte = null) {
    if (pcCompte?.limite_temp &&
        pcCompte?.limite_temp_expiration &&
        new Date(pcCompte.limite_temp_expiration) > new Date()) {
        return pcCompte.limite_temp
    }
    return eglise?.limite_petite_caisse ?? 500
}

export function getPeriodePC(eglise, pcCompte = null) {
    const now = new Date()
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59)

    const exp = pcCompte?.limite_temp_expiration ? new Date(pcCompte.limite_temp_expiration) : null

    // Temp active : de limite_temp_debut à expiration
    if (pcCompte?.limite_temp && exp && exp > now) {
        const debut = pcCompte.limite_temp_debut ? new Date(pcCompte.limite_temp_debut) : startOfMonth
        return { debut, fin: exp }
    }
    // Pas de temp ou expirée : du 1er du mois à la fin du mois
    return { debut: startOfMonth, fin: endOfMonth }
}

// Shifts par jour de la semaine (0=dim → 6=sam)
// Règle : dimanche/lundi/mardi → samedi précédent, mercredi/jeudi/vendredi → samedi suivant
const SAT_SHIFTS = [-1, -2, -3, 3, 2, 1, 0]

export function snapToSaturday(date) {
    const d = moment.utc(date)
    const day = d.day()
    if (day === 6) return d
    return d.clone().add(SAT_SHIFTS[day], 'days')
}
